import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';
import {
  WorkflowDataStore,
  WorkflowDataStoreListFilter,
  WorkflowDataStoreListResult,
  WorkflowDataStorePutIfAbsentResult,
  WorkflowDataStorePutResult,
  WorkflowDataStoreRemoveResult,
} from '../workflow-data-store/workflow-data-store';

@Injectable({ providedIn: 'root' })
export class WorkflowDataStoreService extends WorkflowDataService<WorkflowDataStore> {
  protected override get apiEndpoint(): string {
    return '/workflow-data-stores';
  }

  simpleList(): Observable<WorkflowDataStore[]> {
    return this.http.get<WorkflowDataStore[]>(
      `${this.baseUrl + this.apiEndpoint}/simple`,
    );
  }

  listRecords(
    storeIdentifier: string,
    filter: WorkflowDataStoreListFilter,
  ): Observable<WorkflowDataStoreListResult> {
    return this.http.post<WorkflowDataStoreListResult>(
      `${this.recordsEndpoint(storeIdentifier)}/list`,
      filter,
    );
  }

  putRecord(
    storeIdentifier: string,
    key: string,
    value: unknown,
    expectedValue?: unknown,
  ): Observable<WorkflowDataStorePutResult> {
    return this.http.post<WorkflowDataStorePutResult>(
      `${this.recordsEndpoint(storeIdentifier)}/put`,
      { key, value, expectedValue },
    );
  }

  putRecordIfAbsent(
    storeIdentifier: string,
    key: string,
    value: unknown,
  ): Observable<WorkflowDataStorePutIfAbsentResult> {
    return this.http.post<WorkflowDataStorePutIfAbsentResult>(
      `${this.recordsEndpoint(storeIdentifier)}/put-if-absent`,
      { key, value },
    );
  }

  removeRecord(
    storeIdentifier: string,
    key: string,
  ): Observable<WorkflowDataStoreRemoveResult> {
    return this.http.post<WorkflowDataStoreRemoveResult>(
      `${this.recordsEndpoint(storeIdentifier)}/remove`,
      { key },
    );
  }

  private recordsEndpoint(storeIdentifier: string): string {
    return `${this.baseUrl + this.apiEndpoint}/${encodeURIComponent(storeIdentifier)}`;
  }
}
